import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ToggleArrow from '../toggle-arrow';
import { withToggler } from '../util';
import ClickOutside from '../click-outside';

var getClassName = function getClassName(cls, isToggled) {
  return classnames('csp-page-nav', cls, isToggled && 'active');
};

var PageNav = function PageNav(_ref) {
  var itemIdKey = _ref.itemIdKey,
      current = _ref.current,
      items = _ref.items,
      toggle = _ref.toggle,
      toggleOff = _ref.toggleOff,
      isToggled = _ref.isToggled,
      className = _ref.className,
      renderItem = _ref.renderItem;

  return React.createElement(
    ClickOutside,
    { isActive: isToggled, onClickOutside: toggleOff },
    function (_ref2) {
      var setRef = _ref2.setRef;
      return React.createElement(
        'nav',
        { ref: setRef, className: getClassName(className, isToggled) },
        React.createElement(
          'div',
          { className: 'csp-page-nav__current' },
          React.createElement(
            'button',
            { className: 'csp-page-nav__toggler', onClick: toggle },
            React.createElement(
              'div',
              null,
              current,
              ' ',
              React.createElement(ToggleArrow, { isActive: isToggled })
            )
          )
        ),
        React.createElement(
          'ul',
          null,
          items.map(function (item) {
            return React.createElement(
              'li',
              { key: item[itemIdKey] },
              renderItem(item, toggleOff)
            );
          })
        )
      );
    }
  );
};

PageNav.propTypes = process.env.NODE_ENV !== "production" ? {
  current: PropTypes.node,
  items: PropTypes.array.isRequired,
  itemIdKey: PropTypes.string,
  toggle: PropTypes.func,
  toggleOff: PropTypes.func,
  isToggled: PropTypes.bool,
  className: PropTypes.string,
  renderItem: PropTypes.func
} : {};

export default withToggler()(PageNav);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/page-nav/PageNav.js
// module id = null
// module chunks = 